// Load Bootstrap init
import {initBootstrap} from "./bootstrap.js";
import {initFaqAnchors} from "./faq-anchors.js";

// Loading bootstrap with optional features
initBootstrap({
  tooltip: true,
  popover: true,
  toasts: true,
});

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

// Add the animation hook only when JavaScript is available. Content therefore
// stays visible if scripts fail or are disabled.
document.documentElement.classList.add('has-motion-js');

const revealGroups = [
  ['#jumbotron .top-headline', '#jumbotron .top-text'],
  ['#jumbotron .leaders-mobile figure'],
  ['#bolistky .campaign-section__header', '#bolistky .faq-item'],
  ['#petice .dark-box > h2', '#petice .dark-box > p', '#petice .dark-box > h3', '#podepiste'],
  ['#aktuality .news > h2', '#aktuality .card'],
  ['#kontakt .footer > div'],
];

let revealIndex = 0;
revealGroups.forEach((group) => {
  document.querySelectorAll(group.join(',')).forEach((element, index) => {
    element.classList.add('reveal');
    element.style.setProperty('--reveal-delay', `${Math.min(index % 4, 3) * 70}ms`);
    element.dataset.revealOrder = revealIndex++;
  });
});

if (prefersReducedMotion.matches || !('IntersectionObserver' in window)) {
  document.querySelectorAll('.reveal').forEach((element) => element.classList.add('is-visible'));
} else {
  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    threshold: .08,
    rootMargin: '0px 0px -7% 0px',
  });

  document.querySelectorAll('.reveal').forEach((element) => revealObserver.observe(element));
}

document.querySelectorAll('.faq-item').forEach((item) => {
  const summary = item.querySelector('.faq-item__summary');

  summary.addEventListener('click', (event) => {
    if (prefersReducedMotion.matches) return;

    event.preventDefault();
    item.getAnimations().forEach((animation) => animation.cancel());

    const startHeight = `${item.offsetHeight}px`;

    if (item.open) {
      const endHeight = `${summary.offsetHeight + parseFloat(getComputedStyle(item).paddingTop) * 2}px`;
      const animation = item.animate(
        {height: [startHeight, endHeight], opacity: [1, .94]},
        {duration: 260, easing: 'cubic-bezier(.4, 0, .2, 1)'}
      );

      animation.onfinish = () => {
        item.open = false;
        item.style.height = '';
      };
      return;
    }

    item.open = true;
    const endHeight = `${item.offsetHeight}px`;
    item.animate(
      {height: [startHeight, endHeight], opacity: [.94, 1]},
      {duration: 360, easing: 'cubic-bezier(.2, .75, .25, 1)'}
    ).onfinish = () => {
      item.style.height = '';
    };
  });
});

initFaqAnchors();
